import { MutableRefObject } from 'react';
import { generateUniqueId } from './commonUtils';

export class ImageStore {
   private static instance: ImageStore;
   private store: Map<string, any>;

   private constructor() {
      this.store = new Map();
   }

   public static getInstance(): ImageStore {
      if (!ImageStore.instance) {
         ImageStore.instance = new ImageStore();
      }
      return ImageStore.instance;
   }

   public setItem(key: string, value: any): void {
      this.store.set(key, value);
   }

   public getItem(key: string): any {
      return this.store.get(key);
   }

   public removeItem(key: string): void {
      this.store.delete(key);
   }
}

export const closeImageModalRevamp = (
   { args, onUserAction, additionalData, getState }: any,
   callback: Function
) => {
   const isCloseWithoutUpload = args?.[0] === 'closeWithoutUpload';
   const { storeValues } = getState();
   let isSuccess;

      isSuccess = additionalData?.dataFromWidget?.response?.status === '200';

   isSuccess = isSuccess || isCloseWithoutUpload;

   if (isSuccess) {
      console.log("additionalData?.dataFromWidget?.response?.status closeImageModalRevamp>>>",additionalData?.dataFromWidget?.response?.status)
      callback();
      if (!isCloseWithoutUpload) {

            onUserAction({
               actions: [
                  {
                     type: 'callUtilFunction',
                     payload: {
                        utilName: 'openVideoModal',
                        args: [{}],
                     },
                  },
               ],
            });
         
      }
   } else {
      onUserAction({
         actions: [
            {
               type: 'showToast',
               payload: {
                  title: 'Something went wrong please try again',
                  dismissDuration: 5000,
                  position: 'bottom-center',
                  state: 'error',
                  style: {
                     zIndex: 10000,
                  },
               },
            },
         ],
      });
   }
};

export const handleFaceMatchResponseRevamp = (
   props: any,
   faceMatchFailureCallback: (faceAuthMessage: string) => void
) => {
   const { onUserAction, additionalData, getState } = props;
   const response = additionalData?.dataFromWidget?.response;
   const { storeValues } = getState();
   const DEFAULT_FACE_AUTH_MESSAGE ='To complete verification, it is important that this photo & your Aadhaar photo matches.';
   const imageStore = ImageStore.getInstance();
   const waterMarkUserImage = imageStore.getItem('waterMarkUserImage');
   const actions = [];

   let isSuccess;
   let isFaceMatched;
   let isFaceMatchFailureStatus;
   let faceAuthMessage;

   let headers = {};

       isSuccess = response?.status === '200'; //TODO remove mock
      // isSuccess =  true;
      isFaceMatched = true;
      const failedAuthCheck: any =
         response?.data?.imageValidationResult &&
         Object.keys(response?.data?.imageValidationResult).length > 0 &&
         Object.values(response?.data?.imageValidationResult).find(
            (result: any) => result?.result?.toLowerCase() === 'failed'
         );
      isFaceMatchFailureStatus = !!failedAuthCheck;
      faceAuthMessage = failedAuthCheck?.displayMessage;

   faceAuthMessage = faceAuthMessage || DEFAULT_FACE_AUTH_MESSAGE;
   const blockUser = !isFaceMatched || isFaceMatchFailureStatus;

   if (!isSuccess) {

      actions.push(
         {
            type: 'fullPageLoader',
            payload: {
               show: false,
            },
         },
         {
            type: 'showToast',
            payload: {
               title: 'Something went wrong please try again',
               dismissDuration: 5000,
               position: 'bottom-center',
               state: 'error',
               style: {
                  zIndex: 10000,
               },
            },
         }
      );
   } else {
      if (blockUser) {
         actions.push({
            type: 'fullPageLoader',
            payload: {
               show: false,
            },
         });
         faceMatchFailureCallback(faceAuthMessage);
      } else {
            console.log("additionalData?.dataFromWidget?.response handleFaceMatchResponseRevamp",additionalData?.dataFromWidget?.response)
        
            let apiUrl = 'new-acq/dochub/doc-hub/upload/image';
            const circleId = storeValues?.appData?.address?.circleId;
            const consumerLob = storeValues?.appData?.lob;
            headers = {
               source: 'shop',
               'x-correlation-id': generateUniqueId(),
               'x-consumer-lob': consumerLob,
               circleId
            };
  

         actions.push({
            type: 'apiCall',
            payload: {
               requestType: 'POST',
               apiUrl,
               authTokenGroup: 'SKYC_REVERIFICATION',
               ...{ headers },
               body: waterMarkUserImage,
               onSuccess: {
                  actions: [
                     {
                        type: 'fullPageLoader',
                        payload: {
                           show: false,
                        },
                     },
                    
                     {
                        payload: {
                           args: ['success'],
                           utilName: 'closeImageModalRevamp',
                        },
                        type: 'callUtilFunction',
                     },
                  ],
               },
               onError: {
                  actions: [
                     {
                        type: 'fullPageLoader',
                        payload: {
                           show: false,
                        },
                     },
                     {
                        type: 'showToast',
                        payload: {
                           title: 'something went wrong please try again',
                           dismissDuration: 5000,
                           position: 'bottom-center',
                           state: 'error',
                           style: {
                              zIndex: 10000,
                           },
                        },
                     },
                  ],
               },
            },
         });
      }
   }
   onUserAction({
      actions,
   });
};

export const closeCameraModalWithErrorAction = (
   type: 'image' | 'video',
   artistRef?: MutableRefObject<any>
) => {
   const utilName = type === 'image' ? 'closeImageModalRevamp' : 'closeVideoModalRevamp';
   artistRef?.current?.onUserAction({
      id: 'closeVideoModalAction',
      actions: [
         {
            payload: {
               args: ['closeWithoutUpload'],
               utilName,
            },
            type: 'callUtilFunction',
         },
         {
            type: 'showToast',
            payload: {
               title: 'Allow camera permission \n This is required to take your photo and video for KYC.',
               description: 'Allow camera access from your phone settings to proceed.',
               dismissDuration: 5000,
               position: 'top-center',
               state: 'error',
               style: {
                  zIndex: 10000,
               },
            },
         },
      ],
   });
};
